import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import AboutTeaser from './components/AboutTeaser';

function HomeSEO() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '白洁情感文学精选',
        url: 'https://up-tv.cn',
        description: '以少妇白洁为核心的都市情感文学内容平台，提供故事赏析、人物解读与情感话题讨论',
      },
      {
        '@type': 'WebSite',
        name: '白洁情感文学精选',
        url: 'https://up-tv.cn',
      },
      {
        '@type': 'WebPage',
        name: '少妇白洁——都市情感故事精选集',
        description: '少妇白洁是广受读者关注的都市情感文学作品，深入描绘普通女性在婚姻、家庭与自我成长之间的心路历程',
        url: 'https://up-tv.cn/',
        isPartOf: { '@id': 'https://up-tv.cn/#website' },
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '少妇白洁是一部什么样的作品？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '少妇白洁是一部以当代都市为背景的情感文学作品，讲述了一位普通已婚女性在婚姻、家庭与个人成长之间的心路历程。作品以细腻的笔触描绘了女性在情感世界中的真实体验，引发了广大读者的深刻共鸣。',
            },
          },
          {
            '@type': 'Question',
            name: '白洁的故事适合哪些读者群体？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '白洁的故事特别适合对婚姻情感话题感兴趣的成年读者，尤其是都市已婚女性。作品中关于女性自我成长、婚姻经营的思考，也受到许多关注两性话题的男性读者的喜爱。',
            },
          },
          {
            '@type': 'Question',
            name: '本站是否提供白洁系列完整版阅读？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '本站提供白洁系列故事的情节赏析、人物解读和情感话题讨论。我们致力于从文学评论和文化分析的角度，帮助读者更深入地理解这部作品的内涵与价值。',
            },
          },
        ],
      },
    ],
  };

  return <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>;
}

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <>
      <HomeSEO />
      <Navbar />
      <main>
        <HeroBanner />
        <CategoryNav />
        <FeaturedArticles />
        <LatestArticles />
        <AboutTeaser />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}